<template>
  <div>
    <p class="mb-8">
      {{ t('yard.messages.theFollowingAssetWillDepartAndBeRemovedFromYardManagement') }}:
    </p>

    <div class="d-flex flex-column gap-2 align-start mb-4">
      <template v-if="isAssetContainer">
        <svg-asset-container :rotation="270" class="fix-truck-rotation" />
        <h4 class="text-capitalize">
          {{ asset.code }}
        </h4>
        <v-chip variant="tonal" density="compact">
          <strong>{{ t(`core.yard.assetContainerTypes.${camelCase(asset.type)}`) }}</strong>
        </v-chip>
      </template>
      <template v-else>
        <yard-view-truck class="fix-truck-rotation" :rotation="270" :asset-visit="asset" />

        <h4 class="text-capitalize">
          {{ asset.company?.name ?? asset.companyHint }}
        </h4>
        <v-chip variant="tonal" density="compact">
          <strong>{{ getAssetVisitTypeDisplayName(asset.visitType) }}</strong>
        </v-chip>
      </template>
    </div>
  </div>
</template>
<script>
import { defineComponent, computed } from 'vue';
import useYard from '@/modules/yard/composables/useYard';
import { useI18n } from 'vue-i18n';
import { camelCase } from 'lodash';

export default defineComponent({
  name: 'YardViewDepartDetails',
  methods: { camelCase },
  props: {
    /**
     * It can be an asset visit or an asset container.
     */
    asset: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { t } = useI18n();
    const yardStore = useYard();
    const isAssetContainer = computed(() => yardStore.isAssetContainer(props.asset));

    return {
      t,
      isAssetContainer,
      getAssetVisitTypeDisplayName: yardStore.getAssetVisitTypeDisplayName
    };
  }
});
</script>
